import React from 'react';
import {connect} from 'react-redux';
import util from 'Utils/commonUtil';

// Components
import Header from 'Components/common/Header';
import Anchor from 'Components/common/Anchor';
import SearchInput from 'Components/common/SearchInput';
import ScrollWrapper from 'Components/common/ScrollWrapper';
import F1OrderItem from './F1OrderItem';
import F1PackageOnTheGoItem from './F1PackageOnTheGoItem';
import BackTop from 'Components/common/BackTop';
import {F1_PACKAGE_SORT} from 'Utils/constant';

// Actions
import {
    getF1OrderList,
    getF1PackageOnTheGoList,
    updateF1OrderSearchFields,
    updateF1OrderSearchList,
    updateF1OrderReceiveSearchList,
    updateF1OrderDetails,
    updateF1OrderListSearchFields,
    updateF1OrderList,
    updateF1PackageOnTheGoList,
    updateF1OrderTabActive,
    setF1OrderSource,
    updateF1OrderListPageNum,
    setF1OrderOnGoPackageSource,
    updateF1OrderOnGoPackageListPageNum,
    updateF1OnGoPackageSort,
} from 'Actions/host';
import {T} from 'Actions/translate';

class F1OrderList extends React.Component {
    pager = {
        page: 0,
        length: 10,
        total: 0,
        pageTotal: 9999999999999999999999999,
    };
    packagePager = {
        page: 0,
        length: 10,
        total: 0,
        pageTotal: 9999999999999999999999999,
    };

    state = {
        searchValue: '',
        tabList: [
            {index: 0, text: T('fone_order_on_the_parcel'), tabFlag: 3},
            {index: 1, text: T('user_center_not_receive'), tabFlag: 1},
            {index: 2, text: T('off_the_stocks'), tabFlag: 2},
        ],
        tabActive: 0,
        listLoaded: true,
        currentShipmentSort: F1_PACKAGE_SORT.ASC_SORT,
    };

    componentWillMount() {
        const {tabList} = this.state;
        const {tabActive} = this.props;

        if (tabList[tabActive].tabFlag === 3) {
            if (
                !this.props.fromF1OrderOnGoPackageDetails ||
                this.props.currentF1OrderOnGoPackagePageNum === 0
            ) {
                console.log('111111', this.props.f1OngoPackageIsAsc);
                this.props.updateF1OrderOnGoPackageListPageNum({$set: 0});
                this.packagePager.page = 0;
                this.getF1PackageOnTheGoList();
            } else {
                this.props.setF1OrderOnGoPackageSource({$set: false});
                this.packagePager.page =
                    this.props.currentF1OrderOnGoPackagePageNum;
                this.setState({
                    currentShipmentSort: this.props.f1OngoPackageIsAsc,
                });
                console.log(
                    '222222 this.props.currentF1OrderOnGoPackagePageNum',
                    this.props.currentF1OrderOnGoPackagePageNum,
                );
            }
        } else {
            if (!this.props.fromF1OrderDetails) {
                this.props.updateF1OrderListPageNum({$set: 0});
                this.pager.page = 0;
                this.getList();
            } else {
                this.pager.page = this.props.currentF1OrderPageNum;
            }
        }

        this.props.updateF1OrderSearchList([]);
    }

    handleChangeTab(item) {
        this.props.updateF1OrderTabActive({$set: item.index});
        this.setState({tabActive: item.index, listLoaded: false}, () => {
            const {tabList, tabActive} = this.state;
            if (tabList[tabActive].tabFlag === 3) {
                this.props.updateF1PackageOnTheGoList([]);
                this.packagePager.page = 0;
                this.packagePager.total = 0;
                this.packagePager.pageTotal = 9999999999999999999999999;
                this.getF1PackageOnTheGoList();
            } else {
                this.props.updateF1OrderList([]);
                this.pager.page = 0;
                this.pager.total = 0;
                this.pager.pageTotal = 9999999999999999999999999;
                this.getList();
            }
        });
    }

    getList = () => {
        const {tabList} = this.state;
        const {tabActive} = this.props;

        this.props.setF1OrderSource({$set: false});
        if (this.pager.page >= this.pager.pageTotal) return;

        this.setState({listLoaded: false});

        this.props
            .getF1OrderList({
                pageNum: this.pager.page + 1,
                pageSize: this.pager.length,
                tabFlag: tabList[tabActive].tabFlag,
                queryKey: this.props.queryKey,
            })
            .then((res) => {
                this.pager.page = res.pageNum;
                this.pager.total = res.total;
                this.pager.pageTotal = res.pageTotal;
                this.setState({listLoaded: true});
            });
    };

    getF1PackageOnTheGoList = () => {
        this.props.setF1OrderOnGoPackageSource({$set: false});

        if (this.packagePager.page >= this.packagePager.pageTotal) return;

        this.setState({listLoaded: false}, () => {
            this.props
                .getF1PackageOnTheGoList({
                    pageNum: this.packagePager.page + 1,
                    pageSize: this.packagePager.length,
                    queryKey: this.props.queryKey,
                    isAsc:
                        this.state.currentShipmentSort === 'asc' ? true : false,
                })
                .then((res) => {
                    this.packagePager.page = res.pageNum;
                    this.packagePager.total = res.total;
                    this.packagePager.pageTotal = res.pageTotal;
                    this.setState({listLoaded: true});
                });
        });
    };

    goToSearchPage = () => this.props.history.push('/F1OrderSearchList');

    chooseItem = (item) => {
        this.props.updateF1OrderDetails({});
        this.props.updateF1OrderReceiveSearchList({
            queryKey: {$set: ''},
        });

        const {tabList} = this.state;
        const {tabActive} = this.props;
        if (tabList[tabActive].tabFlag === 3) {
            this.props.updateF1OrderOnGoPackageListPageNum({
                $set: this.packagePager.page,
            });
            console.log(
                'chooseItem this.state.currentShipmentSort',
                this.state.currentShipmentSort,
            );
            this.props.updateF1OnGoPackageSort({
                $set: this.state.currentShipmentSort,
            });
            // this.props.history.push(`/F1OrderOnTheGoPackageReceive/`, {id: 501616, shipmentNumber: 1215753346, orderStatus: 'toBeReceived'});
            this.props.history.push(`/F1OrderOnTheGoPackageReceive/`, {
                id: item.orderId,
                shipmentNumber: item.shipmentNumber,
                f1Number: item.f1Number,
            });
        } else {
            this.props.updateF1OrderListPageNum({$set: this.pager.page});
            switch (item.status) {
                case 1:
                case 4:
                case -1:
                    this.props.history.push(
                        `/F1OrderReceiveManagement/${item.id}`,
                    );
                    break;
                default:
                    this.props.history.push(`/F1OrderDetails/${item.id}`);
            }
        }
    };
    goBack = () => {
        this.props.updateF1OrderListSearchFields({
            queryKey: {$set: ''},
        });
        this.props.history.goBack();
    };

    search = () => {
        const {tabList} = this.state;
        const {tabActive} = this.props;
        if (tabList[tabActive].tabFlag === 3) {
            this.props.updateF1PackageOnTheGoList([]);
            this.props.updateF1OrderOnGoPackageListPageNum({$set: 0});
            this.packagePager.page = 0;
            this.packagePager.total = 0;
            this.packagePager.pageTotal = 9999999999999999999999999;
            this.getF1PackageOnTheGoList();
        } else {
            this.props.updateF1OrderList([]);
            this.props.updateF1OrderListPageNum({$set: 0});
            this.pager.page = 0;
            this.pager.total = 0;
            this.pager.pageTotal = 9999999999999999999999999;
            this.getList();
        }
    };

    onChange = (title, value) => {
        this.props.updateF1OrderListSearchFields({
            [title]: {$set: value},
        });
    };

    f1PackageSort = (sortType) => {
        this.setState(
            {
                currentShipmentSort:
                    sortType === F1_PACKAGE_SORT.ASC_SORT
                        ? F1_PACKAGE_SORT.DESC_SORT
                        : F1_PACKAGE_SORT.ASC_SORT,
            },
            () => {
                console.log(
                    'currentShipmentSort ',
                    this.state.currentShipmentSort,
                );
                this.props.updateF1PackageOnTheGoList([]);
                this.props.updateF1OrderOnGoPackageListPageNum({$set: 0});
                this.packagePager.page = 0;
                this.packagePager.total = 0;
                this.packagePager.pageTotal = 9999999999999999999999999;
                this.getF1PackageOnTheGoList();
            },
        );
    };

    render() {
        const {tabList, listLoaded, currentShipmentSort} = this.state;
        const {F1OrderList, F1PackageOnTheGoList, tabActive} = this.props;

        return (
            <div className="F1-order-list-container">
                <Header
                    hasUserCenter={true}
                    hasArrowBackIos={true}
                    backEvent={this.goBack}>
                    <div className="F1-order-list-header">
                        <div className="F1-order-list-header-title">
                            <h3 className="header-title">
                                {T('header_fone_shippment_management')}
                            </h3>
                        </div>

                        <SearchInput
                            title="queryKey"
                            value={this.props.queryKey}
                            placeholder={
                                tabList[tabActive].tabFlag === 3
                                    ? T('enter_onload_package_search_criteria')
                                    : T('enter_sku_orderNo_EoneNo')
                            }
                            search={this.search}
                            onChange={this.onChange}
                            testid="f1-receipt-search-input"></SearchInput>
                    </div>
                    <div className="tab-header">
                        {tabList.map((item, index) => {
                            return (
                                <div id={'f1OrderTab' + item.index}>
                                    <a
                                        key={item.index}
                                        id={'f1Order' + item.index}
                                        testid={
                                            item.tabFlag === 3
                                                ? 'f1-receipt-tab-in-transit'
                                                : ''
                                        }
                                        className={util.getClassName({
                                            'tab-item': true,
                                            active: index === tabActive,
                                        })}
                                        onClick={() => {
                                            this.handleChangeTab(item);
                                        }}>
                                        {item.text}
                                    </a>

                                    {item.index === 0 && tabActive === 0 && (
                                        <div className="f1-Package-sort">
                                            {currentShipmentSort ===
                                            F1_PACKAGE_SORT.ASC_SORT ? (
                                                <img
                                                    src={
                                                        new URL(
                                                            'Images/sortup.svg',
                                                            import.meta.url,
                                                        ).href
                                                    }
                                                    alt=""
                                                    onClick={() =>
                                                        this.f1PackageSort(
                                                            F1_PACKAGE_SORT.ASC_SORT,
                                                        )
                                                    }
                                                />
                                            ) : (
                                                <img
                                                    src={
                                                        new URL(
                                                            'Images/sortdown.svg',
                                                            import.meta.url,
                                                        ).href
                                                    }
                                                    alt=""
                                                    onClick={() =>
                                                        this.f1PackageSort(
                                                            F1_PACKAGE_SORT.DESC_SORT,
                                                        )
                                                    }
                                                />
                                            )}
                                        </div>
                                    )}
                                </div>
                            );
                        })}
                    </div>
                </Header>
                <ScrollWrapper
                    listLoaded={listLoaded}
                    showAbyss={
                        tabList[tabActive].tabFlag === 3
                            ? this.packagePager.page >=
                              this.packagePager.pageTotal
                            : this.pager.page >= this.pager.pageTotal
                    }
                    showLoadingMore={!listLoaded}
                    getMoreData={
                        tabList[tabActive].tabFlag === 3
                            ? this.getF1PackageOnTheGoList
                            : this.getList
                    }>
                    <ul className="F1-order-list">
                        {tabList[tabActive].tabFlag === 3
                            ? F1PackageOnTheGoList &&
                              F1PackageOnTheGoList.map((item, index) => (
                                  <li key={index} className="F1-order-item">
                                      <F1PackageOnTheGoItem
                                          item={item}
                                          testid={`f1-receipt-order-card-${
                                              item.rtj_order_no ||
                                              item.rtjOrderNo ||
                                              item.number ||
                                              item.orderNumber ||
                                              item.id
                                          }`}
                                          chooseItem={() =>
                                              this.chooseItem(item)
                                          }
                                      />
                                  </li>
                              ))
                            : F1OrderList &&
                              F1OrderList.map((item, index) => (
                                  <li key={index} className="F1-order-item">
                                      <F1OrderItem
                                          item={item}
                                          testid={`f1-receipt-order-card-${
                                              item.rtj_order_no ||
                                              item.rtjOrderNo ||
                                              item.number ||
                                              item.id
                                          }`}
                                          chooseItem={() =>
                                              this.chooseItem(item)
                                          }
                                      />
                                  </li>
                              ))}
                    </ul>
                    <BackTop />
                </ScrollWrapper>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    const {host} = state;
    return {
        F1OrderList: host.F1OrderList,
        F1PackageOnTheGoList: host.F1PackageOnTheGoList,
        queryKey: host.f1OrderListSearchfields.queryKey,
        tabActive: host.tabActive,
        fromF1OrderDetails: host.fromF1OrderDetails,
        currentF1OrderPageNum: host.currentF1OrderPageNum,
        fromF1OrderOnGoPackageDetails: host.fromF1OrderOnGoPackageDetails,
        currentF1OrderOnGoPackagePageNum: host.currentF1OrderOnGoPackagePageNum,
        f1OngoPackageIsAsc: host.f1OngoPackageIsAsc,
    };
};

const mapDispatchToProps = {
    getF1OrderList,
    getF1PackageOnTheGoList,
    updateF1OrderSearchFields,
    updateF1OrderSearchList,
    updateF1OrderReceiveSearchList,
    updateF1OrderDetails,
    updateF1OrderListSearchFields,
    updateF1OrderList,
    updateF1PackageOnTheGoList,
    updateF1OrderTabActive,
    setF1OrderSource,
    updateF1OrderListPageNum,
    setF1OrderOnGoPackageSource,
    updateF1OrderOnGoPackageListPageNum,
    updateF1OnGoPackageSort,
};

export default connect(mapStateToProps, mapDispatchToProps)(F1OrderList);
